import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import OrganizationForm from '../components/OrganizationForm';
import { useDispatch, useSelector } from 'react-redux';
import { cancelOrganizationCreate, createOrganizationRequest } from '../../api/organizations/organizationSlice';
import { clearSelectedPartner } from '../../api/partners/partnerSlice';

const OrganizationCreatePage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { isOrganizationCreated } = useSelector((state) => state.organizations);

  useEffect(() => {
    if (isOrganizationCreated) {
      navigate('/organizations');
    }
  }, [isOrganizationCreated, navigate]);

  const handleCreate = async (data) => {
    dispatch(createOrganizationRequest(data));
  };

  function handleCancel() {
    dispatch(cancelOrganizationCreate());
    dispatch(clearSelectedPartner());
    return navigate('/organizations');
  }

  return (
    <Box elevation={3} sx={{ p: 4 }}>
      <Typography variant="h4" gutterBottom>
        Create Organization
      </Typography>
      <OrganizationForm
        onSubmit={handleCreate}
        onCancel={handleCancel}
        buttonText="Save"
        initialData={{ name: '', email: '', contact_emails: [], partner_id: '' }}
      />
    </Box>
  );
};

export default OrganizationCreatePage;
